import i18n from 'i18next';
import {type FC, useEffect} from 'react';

const RedirectLogin: FC = () => {
  useEffect(() => {
    const lang = i18n.resolvedLanguage || 'es';
    window.location.replace(`/${lang}/login?redirect=/admin`);
  }, []);

  return null;
};

export default RedirectLogin;
